import { gql } from '@apollo/client';

export const GET_LOADING_ORDER_DETAIL_WAYPOINT_PARCEL_COUNTS_BY_TASK_ID = gql`
    query GetLoadingOrderDetailWaypointParcelCountsByTaskId($taskId: Long!) {
        getLoadingOrderDetailWaypointParcelCountsByTaskId(taskId: $taskId) {
            waypointId
            parcelCount
        }
    }
`;

export interface TmsWaypointParcelCountType {
    waypointId: number;
    parcelCount: number;
}

export interface GetLoadingOrderDetailWaypointParcelCountsByTaskIdResponse {
    getLoadingOrderDetailWaypointParcelCountsByTaskId: TmsWaypointParcelCountType[];
}

export interface GetLoadingOrderDetailWaypointParcelCountsByTaskIdVariables {
    taskId: number;
}

